<template>
  <div v-if="loaded">
    <drop-down
      id="budget-positionType"
      label="Position type:"
      v-model="selectedPositionType"
      :items="positionTypeItems"
      :include-empty-option="true"
      empty-option-message="Select..."
    />
    <tree-drop-down
      label="Segment code:"
      v-model="selectedCode"
      :items="codeItems"
    />
    <div v-if="allowTotals && selectedPositionType">
      <radio-button
        v-model="selectedTotal"
        value="total"
        id="total-type-total"
        name="total-selector"
        label="Total"
      />
      <radio-button
        v-if="rollUpSelected"
        v-model="selectedTotal"
        value="totalByRollUp"
        id="total-type-rollup"
        name="total-selector"
        label="Total By Roll Up Code"
      />
    </div>
    <div class="d-flex mt-1">
      <button
        class="btn btn-primary"
        type="button"
        :disabled="resolvedDisabled"
        @click="resolveClicked"
      >
        Resolve
      </button>
    </div>
  </div>
</template>
<script>
import TreeDropDown from "@/components/common/forms/TreeDropDown.vue";
import graph from "@/services/sharedo/graphService";
import { ascending } from "@/util/sort";

const loadBudgetStructure = async function () {
  this.budgetStructure = await graph.getBudgetStructure(
    this.budgetStructureSystemName
  );

  this.loaded = true;
};

const resolveClicked = function () {
  const args = {
    positionType: this.selectedPositionType,
    code: this.selectedCode,
    total: this.selectedTotal,
  };

  this.$emit("resolve", {
    fieldQueryName: this.query.name,
    args,
  });
};

export default {
  components: { TreeDropDown },
  props: {
    field: {
      required: true,
    },
  },
  data: function () {
    return {
      budgetStructure: null,
      loaded: false,
      selectedPositionType: "",
      selectedCode: undefined,
      selectedTotal: "",
    };
  },
  computed: {
    query: function () {
      return this.field.value.queries.find(
        (q) => q.query.name === "query.budgetAmount"
      );
    },
    budgetStructureSystemName: function () {
      return this.query.query.widgetConfig.budgetStructureSystemName;
    },
    allowTotals: function () {
      return this.query.query.widgetConfig.allowTotals;
    },
    positionTypeItems: function () {
      if (this.budgetStructure && this.budgetStructure.positionTypes) {
        const positionTypes = [...this.budgetStructure.positionTypes];
        positionTypes.sort(ascending((posType) => posType.name));

        return positionTypes.map((posType) => ({
          label: posType.name,
          value: posType.systemName,
        }));
      }
    },
    hasRollUps: function () {
      return this.rollUpCodes.length > 0;
    },
    rollUpCodes: function () {
      return this.budgetStructure.rollUpCodes;
    },
    rollUpSelected: function () {
      return (
        this.hasRollUps &&
        this.rollUpCodes.some((rollUp) => rollUp.code === this.selectedCode)
      );
    },
    codeItems: function () {
      const primaryCodes = [...this.budgetStructure.primaryCodes];
      primaryCodes.sort(ascending((code) => code.displayName));

      if (this.hasRollUps) {
        const codeItems = this.rollUpCodes.map((code) => ({
          id: code.code,
          label: code.name,
        }));

        codeItems.sort(ascending((code) => code.label));

        codeItems.forEach((codeItem) => {
          codeItem.children = primaryCodes
            .filter((primaryCode) => primaryCode.parentCode === codeItem.id)
            .map((code) => ({
              id: code.code,
              label: code.name,
            }));
        });

        return codeItems;
      } else {
        return primaryCodes.map((primaryCode) => ({
          id: primaryCode.code,
          label: primaryCode.displayName,
        }));
      }
    },
    resolvedDisabled: function () {
      return !this.selectedPositionType;
    },
  },
  watch: {
    selectedCode: function (newValue) {
      if (!!newValue && this.selectedTotal === "total") {
        this.selectedTotal = "";
      }
    },
    rollUpSelected: function (selected) {
      if (!selected && this.selectedTotal === "totalByRollUp") {
        this.selectedTotal = "";
      }
    },
    selectedTotal: function (newValue) {
      if (newValue === "total") {
        this.selectedCode = undefined;
      }
    },
  },
  methods: {
    loadBudgetStructure,
    resolveClicked,
  },
  emits: ["resolve"],
  mounted: loadBudgetStructure,
};
</script>